import { useEffect } from "react";

/**
 * Updates page <title>, <meta name="description">, and OpenGraph/Twitter tags
 * per-route. Critical for SPA SEO so each URL has unique meta and isn't
 * considered duplicate content by Google.
 *
 * Usage in a page component:
 *   <PageMeta
 *     title="Concept — Sponsormania.fr"
 *     description="Découvrez comment Sponsormania met en relation clubs amateurs et sponsors locaux."
 *   />
 */
export default function PageMeta({ title, description, image }) {
    useEffect(() => {
        if (title) {
            document.title = title;
            setOgMeta("og:title", title);
            setOgMeta("twitter:title", title, "name");
        }
        if (description) {
            setNamedMeta("description", description);
            setOgMeta("og:description", description);
            setOgMeta("twitter:description", description, "name");
        }
        if (image) {
            setOgMeta("og:image", image);
            setOgMeta("twitter:image", image, "name");
        }
    }, [title, description, image]);

    return null;
}

function setNamedMeta(name, content) {
    let el = document.querySelector(`meta[name="${name}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

function setOgMeta(property, content, attr = "property") {
    let el = document.querySelector(`meta[${attr}="${property}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, property);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}
